// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false , 
  firebase : {
    apiKey: "AIzaSyBz-v9i65v_4ZVQ__GVTq-DKBUsZ36rFw0",
  authDomain: "easy-course-81781.firebaseapp.com",
  databaseURL: "https://easy-course-81781-default-rtdb.firebaseio.com",
  projectId: "easy-course-81781",
  storageBucket: "easy-course-81781.appspot.com",
  messagingSenderId: "888627571972",
  appId: "1:888627571972:web:2e4cbe16794f8eafdf3451",
  measurementId: "G-G93973Q1P8"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
